import Scene from "./Scene";
import common from "../common";
import ControlPoint from "../ui/ControlPoint";
import Bezier from 'bezier-js';

export default class SplineEditorScene extends Scene {
    constructor() {
        super();
    }

    init() {
        super.init();

        this._interactionLayer = new PIXI.Container();
        this._interactionLayer.interactive = true;
        this._interactionLayer.hitArea = new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this._interactionLayer.mousedown = this._onDown.bind(this);
        this.addChild(this._interactionLayer);

        this._curveLayer = new PIXI.Container();
        this.addChild(this._curveLayer);

        this._points = [];
        this._curves = [];

        /*
        this._layer = new PIXI.Container();
        this._layer.y = common.STAGE_HEIGHT * 0.5;
        this.addChild(this._layer);

        this._view = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._view.anchor.set(0.5);
        this._layer.addChild(this._view);

        gsap.to(this._view, {
            motionPath: {
                path: "#path",
                align: "#path",
                alignOrigin: [0.5, 0.5],
                useRadians: true,
                autoRotate: true
                //autoRotate: 90
            },
            //transformOrigin: "50% 50%",
            duration: 10,
            ease: "none"
        });

         */

    }

    resize() {
        super.resize();
    }

    animateIn() {

    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();

        // nuke container and rebuild children each frame, isn't efficient but doesn't matter as its only an editor.
        this._curveLayer.transform && this._curveLayer.destroy({children: true});
        this._curveLayer = new PIXI.Container();
        this.addChild(this._curveLayer);

        for (let i = 0; i < this._curves.length; i++) {

            // update points
            const curve = this._curves[i];
            curve.points[0].x = curve.point1.x;
            curve.points[0].y = curve.point1.y;
            curve.points[1].x = curve.controlPoint.x;
            curve.points[1].y = curve.controlPoint.y;
            curve.points[2].x = curve.point2.x;
            curve.points[2].y = curve.point2.y;

            if (i > 0) {

                // check tangents
                const lastCurve = this._curves[this._curves.length - 1];
                const d0 = lastCurve.derivative(1);
                const d1 = curve.derivative(0);

                if (d0.x !== d1.x || d0.x !== d1.y) {
                    //console.log(Math.abs(d0.x - d1.x) + Math.abs(d0.y - d1.y))
                    //console.log(Math.abs(d0 - d1));
                   // console.log(d0, d1)
                }

                /*
                // blend control points
                const lastCurve = this._curves[i - 1];
                const x = (lastCurve.controlPoint.x + curve.controlPoint.x) * 0.5;
                const y = (lastCurve.controlPoint.y + curve.controlPoint.y) * 0.5;
                //   lastCurve.controlPoint.position.set(x, y);
                //   curve.controlPoint.position.set(-x, -y);
                lastCurve.points[1].x = x;
                lastCurve.points[1].y = y;
                curve.points[1].x = x;
                curve.points[1].y = y;

                 */
            }

            // get steps and add them to scene
            const steps = curve.getLUT(20);
            for (let i = 0; i < steps.length; i++) {
                const sp = new PIXI.Sprite(PIXI.Texture.WHITE);
                sp.width = 2;
                sp.height = 2;
                sp.position.set(steps[i].x, steps[i].y);
                this._curveLayer.addChild(sp);
            }

        }

        if (P3.input.isKeyPressed(P3.keys.SPACE)) {
            this.saveCurves();
        }

        this._shiftDown = !!P3.input.isKeyDown(P3.keys.SHIFT);
    }

    saveCurves() {

        const arr = [];
        for (let i = 0; i < this._curves.length; i++) {
            const curve = this._curves[i];
            arr.push({
                point1: {x: curve.point1.x, y: curve.point1.y},
                point2: {x: curve.point2.x, y: curve.point2.y},
                controlPoint: {x: curve.controlPoint.x, y: curve.controlPoint.y},
            });
        }

        localStorage.setItem('curves', JSON.stringify(arr));

        const scale = 4;

        const offset = new PIXI.Point(this._points[0].x, this._points[0].y);
        offset.x *= scale;
        offset.y *= scale;

        const arr2 = [];
        for (let i = 0; i < this._points.length; i++) {
            const p = this._points[i];
            arr2.push({x: p.x * scale - offset.x, y: p.y * scale - offset.y});
        }

        localStorage.setItem('points', JSON.stringify(arr2));

    }

    end() {

    }

    addPoint(position) {
        const p = new ControlPoint();
        p.position = position;
        this.addChild(p);

        if (this._points.length > 0) {
            // connect last point with bezier
            const last = this._points[this._points.length - 1];
            const cp = new ControlPoint();
            cp.tint = 0xff0000;
            cp.position.set(p.x - 70, p.y - 10);
            this.addChild(cp);

            const curve = new Bezier(p.x, p.y, cp.x, cp.y, last.x, last.y);
            this._curves.push(curve);

            curve.point1 = last;
            curve.controlPoint = cp;
            curve.point2 = p;
        }

        this._points.push(p);
    }

    _onDown(event) {
        if (!this._shiftDown) {
            // add point
            const p = event.data.getLocalPosition(this);
            this.addPoint(p);
        } else {
            // remove last point
            this._points[this._points.length - 1].destroy();
            this._points.splice(this._points.length - 1, 1);
            this._curves[this._curves.length - 1].controlPoint.destroy();
            this._curves.splice(this._curves.length - 1, 1);
        }

    }
}